import React, { useEffect, useRef } from 'react';
import Image from 'react-bootstrap/Image';
import useWidth from '../Functions/useWidth';
import Carousel from 'react-bootstrap/Carousel';

export default function MyCarousel({ slides }) {
  const slidesRef = useRef([])
  const width = useWidth()

  useEffect(() => {
    const heights = slidesRef.current.map(slide => slide.img?.naturalHeight || 0);
    const minHeight = Math.min(...heights.filter(h => h > 0));

    slidesRef.current.forEach(slide => {
      if (slide.img) {
        slide.img.style.height = minHeight + 'px';
        slide.img.style.objectFit = 'cover';
      }
    });
  }, [slides]);

  const handleImageRef = (el, index) => {
    if (!slidesRef.current[index]) slidesRef.current[index] = {};
    slidesRef.current[index].img = el;
  };

  const handleCaptionRef = (el, index) => {
    if (!slidesRef.current[index]) slidesRef.current[index] = {};
    slidesRef.current[index].caption = el;
  };

  return (
    <>
      <style>{`
        .carousel-caption {
          position: static;  /* remove absolute positioning */
          padding-top: 10px; /* spacing from image */
          background: transparent;
        }
        .carousel-control-prev-icon,
        .carousel-control-next-icon {
          background-image: none; /* remove default white arrow */
        }
        .carousel-control-prev-icon::after,
        .carousel-control-next-icon::after {
          content: '';
          display: inline-block;
          width: 20px;
          height: 20px;
          border-top: 3px solid #00e5ff;
          border-right: 3px solid #00e5ff;
        }
        .carousel-control-prev-icon::after {
          transform: rotate(-135deg);
        }
        .carousel-control-next-icon::after {
          transform: rotate(45deg);
        }
				.carousel-item img {
					display: block;
					margin: 0 auto;
				}
      `}
      </style>  
      <Carousel>
        {slides.map((slide, index) => (
          <Carousel.Item key={index}>
            <img
              ref={el => handleImageRef(el, index)}
              src={slide.src}
              alt={slide.title}
              style={{opacity:'75%'}}
            />
            <Carousel.Caption ref={el => handleCaptionRef(el, index)}>
              <h3 className='logoFont' style={
                width > 800 ?
                {color:'#00e5ff', fontSize:'1.4em'} : {color:'#00e5ff', fontSize:'1.2em'}
              }>{slide.captionTitle}</h3>
              <p className='logoFont' style={width > 800 ? {color:'#F5F5FC', fontSize:'1em'} : {color:'#F5F5FC', fontSize:'.8em'}}>{slide.captionText}</p>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>
    </>
    
  );
}